export const CHECKBOX_INPUT = 'checkbox';
